"use strict";
(self["webpackChunkshop_chunks"] = self["webpackChunkshop_chunks"] || []).push([[672],{

/***/ 4672:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ drawerCollection)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9755);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);

function drawerCollection ({ wrapper }) {
const sortDrawerBtn = document.getElementById('open-sort-drawer-btn')
const sortByDrawer = document.getElementById('sort-by-drawer')
const closeSortDrawerBtn = document.getElementById('close-sort-drawer-btn')

const sortModal = document.getElementById("sortModal")
sortDrawerBtn.addEventListener('click', ()=>{
    toggleSortDrawerOpen()
    sortModal.style.display = "block";
    document.body.style.overflow = 'hidden'
})
closeSortDrawerBtn.addEventListener('click', ()=>{
    removeSortOpen()
    sortModal.style.display = "none";
    document.body.style.overflow = 'visible'
})

function toggleSortDrawerOpen(){
    sortByDrawer.classList.toggle('open')
}

function removeSortOpen(){
    sortByDrawer.classList.remove('open')
}

const filterDrawerBtn = document.getElementById('open-filter-drawer-btn')
const filterDrawer = document.getElementById('filter-drawer')
const closeFilterDrawerBtn = document.getElementById('close-filter-drawer-btn')
const filterModal = document.getElementById("filterModal")
filterDrawerBtn.addEventListener('click', ()=>{
    toggleFilterDrawerOpen()
    filterModal.style.display = "block";
    document.body.style.overflow = 'hidden'
})
closeFilterDrawerBtn.addEventListener('click', ()=>{
    removeDrawerOpen()
    document.body.style.overflow = 'visible'
    filterModal.style.display = "none";

})

function toggleFilterDrawerOpen(){
    filterDrawer.classList.toggle('open')
}

function removeDrawerOpen(){
    filterDrawer.classList.remove('open')
}

// Modal for Filter and Sort By Drawer
window.onclick = function(event) {
    if (event.target == filterModal) {
        filterModal.style.display = "none";
        toggleFilterDrawerOpen()
        document.body.style.overflow = 'visible'
    }
    if (event.target == sortModal) {
        sortModal.style.display = "none";
        toggleSortDrawerOpen()
        document.body.style.overflow = 'visible'
  }
}
// Ending Curly Bracket for wrapper 
}



/***/ })

}]);